import React, { memo } from 'react'

import { Icon, LayoutSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

const iconSize = {
  height: '20px',
  width: '20px',
}

function Header({ isOpen, handleToggleSidebar }) {
  return (
    <div
      role="button"
      tabIndex={0}
      className="sidebar__header"
      onClick={handleToggleSidebar}
    >
      {!isOpen && (
        <span className="sidebar__header-icon">
          <Icon
            svgComponent={LayoutSidebar}
            color="dark"
            size={iconSize}
            notSpaced
          />
        </span>
      )}
      {isOpen && (
        <>
          <span className="sidebar__header-title">CGTrader AI</span>
          <Icon
            className="sidebar__header-trail"
            svgComponent={LayoutSidebar}
            color="dark"
            size={iconSize}
            notSpaced
          />
        </>
      )}
    </div>
  )
}

Header.propTypes = {
  isOpen: bool.isRequired,
  handleToggleSidebar: func.isRequired,
}

export default memo(Header)
